import { initializeTireFinder } from './components/TireFinder/initializeTireFinder';

initializeTireFinder(true);
